import React from "react";
import { Box, Container } from "@mui/material";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import HeroCst from "@components/HeroCst";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import CoursesFormCst from "@pages/Contents/Corporate/Catalog/Courses/CoursesFormCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useEditCourses } from "@hooks/hookscatalog/Courses/useEditCourses";
import { PagesID } from "@utils/utilsConfigurations";

const EditCoursesDigited: React.FC = () => {
  const { t } = useTranslation(["courses-digited-page"]);
  const { idCourses } = useParams();

  const navigate = useNavigate();

  const {
    onSubmit,
    openToast,
    setOpenToast,
    columns,
    dataDetail,
    actionsForForms,
  } = useEditCourses(PagesID["catalog.courses"], "1", idCourses);

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-courses.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("edit.hero-title")}
          description={t("edit.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <CoursesFormCst
              row={{ ...dataDetail }}
              columns={columns}
              onSubmit={onSubmit}
              backButton={() => {
                navigate(`/catalog/courses`);
              }}
              idEntity={idCourses}
              actionsForForms={actionsForForms}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-add")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default EditCoursesDigited;
